import { render, staticRenderFns } from "./LeadsType.vue?vue&type=template&id=2652f11a&"
import script from "./LeadsType.vue?vue&type=script&lang=js&"
export * from "./LeadsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports